import { useContext } from 'react';
import { ClipboardContext } from '../context';

export function useClipboard() {
  const context = useContext(ClipboardContext);
  return { ...context };
}
